import Input from './Input';
import Button from './Button';
import AutoSearch from './AutoSearch';
import SelectBox from './select';
import DatePicker from './DatePicker';
import RadioButton from './RadioGroup';
import InlineRadioButton from './InlineRadioGroup';
import TextArea from './TextArea';
import InputField from './InputField';
import CustomAutoSearch from './customAutoSearch';
import Checkbox from './Checkbox';
import InlineInput from './InlineInput';
import InlineDatePicker from './InlineDatePicker';
import InlineSelect from './InlineSelect';
import InlineAutoSearch from './InlineAutoSearch';
import MaskedInput from './MaskedInput';
import MaskedInputC from './MaskedInputC';
import InlineMaskedInput from './InlineMaskedInput';
import InlineMaskedInputC from './InlineMaskInputC';
import TimePicker from './TimePicker';
import ReactSelect from './ReactSelect';
import InlineInputAdornment from './InlineInputAdornment';
import CommonTextField from './CommonTextField';

const Controls = {
  Input,
  Button,
  AutoSearch,
  SelectBox,
  DatePicker,
  RadioButton,
  TextArea,
  InputField,
  CustomAutoSearch,
  Checkbox,
  InlineInput,
  InlineDatePicker,
  InlineSelect,
  InlineAutoSearch,
  MaskedInput:MaskedInputC,
  InlineMaskedInput:InlineMaskedInputC,
  TimePicker,
  InlineRadioButton,
  ReactSelect,
  InlineInputAdornment,
  MaskedInputC:MaskedInput,
  InlineMaskedInputC:InlineMaskedInput
};

export default Controls;
